__turbopack_context__.v({
  "plcta": "PLCTA-module__YE7_FG__plcta",
  "plctaGlass": "PLCTA-module__YE7_FG__plctaGlass",
  "plctaHideOnDesktop": "PLCTA-module__YE7_FG__plctaHideOnDesktop",
  "plctaPrimary": "PLCTA-module__YE7_FG__plctaPrimary",
  "plctaWhite": "PLCTA-module__YE7_FG__plctaWhite",
});
